"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDrawer = void 0;
const react_1 = require("react");
const Drawer_1 = require("../components/Drawer");
function useDrawer() {
    const { expanded, setExpanded, breakpointInPixels } = react_1.useContext(Drawer_1.DrawerContext);
    return { expanded, setExpanded, breakpointInPixels };
}
exports.useDrawer = useDrawer;
//# sourceMappingURL=useDrawer.js.map